import app from '../../app';
import { KeyValueGambit } from '../IGambit';
export default class GroupGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('core.lib.gambits.users.group.key', {}, true);
  }
  canonicalKey() {
    return 'group';
  }
  hint() {
    return app.translator.trans('core.lib.gambits.users.group.hint', {}, true);
  }
  filterKey() {
    return 'group';
  }
}
flarum.reg.add('core', 'common/query/users/GroupGambit', GroupGambit);